import styled from 'styled-components';
import { BlackButton, CheckCircle, TypographyStyles, colours, fonts, media, spacing } from '@storefront/lib-global';

export const Wrapper = styled.form`
  margin-top: ${spacing.XXS};
`;
export const Label = styled.span`
  ${TypographyStyles.CallToAction.Tiny.Regular}
`;
export const EmailInput = styled.input<{ hasError: boolean }>`
  border: solid 1px;
  border-color: ${({ hasError }) => (hasError ? colours.ERROR_PRIMARY : colours.GREY)};
  border-radius: 0;
  margin-bottom: ${({ hasError }) => (hasError ? '0px' : '8px')};
  margin-top: 8px;
  min-height: 48px;
  outline: none;
  padding: 0 ${spacing.XS};
  width: 100%;
  ${TypographyStyles.Body.Medium.Regular}

  @media ${media.greaterThan('lg')} {
    font-size: 16px;
  }
`;
export const SubmitBtn = styled(BlackButton)`
  ${TypographyStyles.Button.SemiBold}
  ${fonts.Montserrat}
  background-color: ${colours.BLACK};
  border: 0;
  color: ${colours.WHITE};
  height: 50px;
  justify-content: center;
  text-transform: initial;
  width: 100%;

  &:hover,
  &:focus {
    background-color: ${colours.WHITE};
    border: 1px solid ${colours.BLACK};
    color: ${colours.BLACK};
  }
`;
export const SuccessMessage = styled.div`
  align-items: center;
  background-color: ${colours.LIGHT_GREY_2};
  display: flex;
  flex-direction: row;
  padding: 20px;
  width: 100%;

  @media ${media.greaterThan('lg')} {
    align-items: center;
  }
`;
export const SuccessText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  margin-left: 15px;
`;

export const SuccessIcon = styled(CheckCircle)`
  flex-shrink: 0;
  height: 25px;
  width: 25px;
  path {
    transform: ${'scale(1.5625)'};
  }
`;

export const Text = styled.span`
  ${fonts.Montserrat}
  color: ${colours.SUCCESS_PRIMARY};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;

  @media ${media.greaterThan('lg')} {
    font-size: 16px;
    line-height: 24px;
  }
`;
export const Title = styled.span`
  ${fonts.Montserrat}
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
`;
export const BoldText = styled.span`
  font-weight: bold;
`;
